import axios from 'axios';

// axios instance منفصل تمامًا لطلبات الزائر في الشات.
// السبب: apiService الرئيسي بيحط adminToken تلقائيًا على كل الطلبات
// عن طريق interceptor، فلو حد فتح الموقع كزائر بعد ما كان مسجل دخول
// كأدمن من قبل (أو التوكن لسه محفوظ في localStorage)، كل رسالة هتتبعت
// ومعاها توكن الأدمن، فالباك إند هيسجلها كـ "admin" بدل "visitor".
// عشان كده الشات بتاع الزائر لازم يستخدم axios instance مستقل
// من غير أي Authorization header خالص.

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const publicChatApi = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// تأكيد إضافي: نمسح أي Authorization header لو حصل وانضاف بالغلط
publicChatApi.interceptors.request.use((config) => {
  delete config.headers.Authorization;
  delete config.headers.authorization;
  return config;
});

publicChatApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (!error.response) {
      return Promise.reject(new Error('Network error. Please check your connection.'));
    }
    return Promise.reject(error);
  }
);

export default publicChatApi;